import React from "react";
import { WeekFilters } from "./WeekFilters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./weekHelpers";
import { PlanningTemplate } from "./PlanningTemplate";
import { WeekNavigationFilter } from "components/filters/components/WeekNavigationFilter";
import { useLoaderData } from "react-router";
import FlightApp from "flights/new/app";
import TrainModal from "train/TrainModal";

export const PlanningWeekApp = () => {
  const viewModel = useLoaderData<server.viewmodel.WeekViewForInternalFrontModel>();

  return <>
    <FlightApp />
    <TrainModal />
    <PlanningTemplate
      filterSet="planning_Week"
      initialInstruction={viewModel.initialInstruction}
      defaultFilters={viewModel.defaultFilters}
      fetchFunction={window.CoreApi.Planning.PlanningByWeekForInternal}
      mapFilterValuesToInstruction={mapFilterValuesToInstruction}
      mapResponseToFilterValues={mapResponseToFilterValues}
      filterComp={<WeekFilters />}
      paginationComp={<WeekNavigationFilter />}
      maxEntriesPerColumn={20}
      filterPreset={{
        mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForPlanningByWeek,
        listApi: window.CoreApi.FilterPreset.ListFilterPresetsForPlanningByWeek
      }}
    />
  </>
};